// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"9f3c46c4b35c31febf30","135":"500eeb8e136dccfd59e0","136":"01031b33d24ab25beb3b","184":"1639299cc4709c18d6c6"}[chunkId] + ".chunk.js";
};